import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { ARTICLE_CANDIDATES } from './articleCandidates.query';
import { ArticleCandidates, ArticleCandidatesVariables } from './__generated__/ArticleCandidates';

export const useArticleCandidates = () => {
  return useLazyQuery<ArticleCandidates, ArticleCandidatesVariables>(ARTICLE_CANDIDATES, {
    client: kmsClient,
    fetchPolicy: 'no-cache'
  });
};
